<template>
  <div :class="elem.classes">
    <div class="row" :class="{ [`-mx-${paddingClosest}`]: Boolean(paddingClosest) }">
      <div :class="elemLabel.classes">
        <FormLabel 
          v-if="!$slots.label"  
          :class="elemFormLabel.classes" 
          :label="label" 
          :labelFont="labelFont"
          :labelTextClass="labelTextClass"
          :labelHint="labelHint"
          :labelHelp="labelHelp"
          :labelRequired="labelRequired"
        />
        <slot name="label" v-else></slot>
      </div>
      <div :class="elemContent.classes">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import FormLabel from "@components_system/Shared/Elements/Texts/FormLabel";

export default {
  components: {
    FormLabel,
  },
  props: {
    // Options
    split: {
      type: String,
      default: () => "default", // default, auto, 6:6, ...
    },
    paddingClosest: {
      // type: [String, Number],
      default: undefined, // 5, 10
    },

    /**
     * Label and Control is disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    // Label
    label: {
      type: String,
      default: () => "",
    },
    labelClass: {
      type: [String, Object],
      default: () => {},
    },
    labelFont: {
      type: String,
      default: undefined,
    },
    labelTextClass: {
      type: String,
      default: undefined,
    },
    labelHint: {
      type: String,
      default: undefined, // Ex. (Hover)
    },
    labelHelp: {
      type: String,
      default: undefined, // Ex. message
    },
    labelRequired: {
      type: Boolean,
      default: false,
    },
    labelValign: {
      type: String,
      default: undefined, // top, center, bottom
    },

    // Content
    contentClass: {
      type: [String, Object],
      default: () => {},
    },
  },
  computed: {
    // Root
    _labelClass() {
      if (typeof this.labelClass === 'string') return this.labelClass.split(" ").reduce((acc, curr)=> ({...acc, [curr]: true}), {});
      return this.labelClass;
    },
    _contentClass() {
      if (typeof this.contentClass === 'string') return this.contentClass.split(" ").reduce((acc, curr)=> ({...acc, [curr]: true}), {})
      return this.contentClass;
    },

    // Elements
    elem() {
      return { 
        classes: {
          'mwe-formgroup-horizontal': true,
          'disabled': Boolean(this.disabled),
        },
      };
    },
    elemLabel() {
      let col = this.split == "default" ? 'col-6'
                : this.split == "auto" ? 'col'
                : `col-${this.split.split(":")[0]}`;
      let valign = this.labelValign == "top" ? 'align-self-start'
                : this.labelValign == "center" ? 'align-self-center'
                : this.labelValign == "bottom" ? 'align-self-end'
                : undefined;
      return { 
        classes: {
          [col]: true,
          [`px-${this.paddingClosest}`]: Boolean(this.paddingClosest),
          [valign]: Boolean(valign),
          ...this._labelClass,
        },
      };
    },
    elemContent() {
      let col = this.split == "default" ? 'col-6'
                : this.split == "auto" ? 'col-auto'
                : `col-${this.split.split(":")[1]}`;
      return { 
        classes: {
          [col]: true,
          [`px-${this.paddingClosest}`]: Boolean(this.paddingClosest),
          ...this._contentClass,
        } 
      };
    },
    elemFormLabel() {
      return { 
        classes: {
          "mb-0": true,
          "mt-5": Boolean(!this.labelValign), // not use when use labelValign
        },
      };
    },
  }
}
</script>

<style>
.mwe-formgroup-horizontal.disabled {
  cursor: auto !important;
  opacity: 0.3;
}
.mwe-formgroup-horizontal.disabled * {
  cursor: auto !important;
}
</style>
